<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'EmailList'
    };
</script>

<style>
</style>
